(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('statistics', {
            parent: 'account',
            url: '/statistics',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN', 'PERM_USER_MINISTRY'],
                pageTitle: 'global.menu.account.statistics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/statistics/statistics.html',
                    controller: 'StatisticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statistics');
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('client');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
